import React, { Fragment } from 'react';
import tabs from './data/tabs';

import GoFetch from '~/js/modules/fetchling';

import ClickOut from '~/js/components/global/ClickOut';
import Spinner from '~/js/components/general/Spinner';
import Select from '~/js/components/general/Select';

import EventItem from '../redlane-spa/EventItem';
import BookPopover from '../redlane-spa/BookPopover';
import QuickQuote from '~/js/components/global/QuickQuote';

const fetch = new GoFetch();
const { resortList } = window.beaches_app.page;

export default class SpaTeens extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      eventsData: null,
      isLoading: true,
      priceChecked: {},
      resortChecked: {},
      tabChecked: {
        [tabs[tabs.length - 1].id]: tabs[tabs.length - 1]
      },
    };
  }
  getData = () => {
    const { resortChecked } = this.state;
    const selectedResort = Object.values(resortChecked)[0];
    const data = {
      rstCode: selectedResort.code,
      groupId: [2, 10, 11, 13]
    };

    this.setState({ isLoading: true });

    fetch.post('/events/fetchSpas/', null, data)

      .then((response) => {
        const { events } = response.data;
        const eventsObj = {};

        for (const item of events) {
          item.rates = item.rates.map((el) => {
            el.duration = item.duration;

            return el;
          });

          if (eventsObj[item.eventName]) {
            eventsObj[item.eventName].rates.push(...item.rates);
          } else {
            eventsObj[item.eventName] = item;
          }
        }

        this.setState(
          { eventsData: Object.values(eventsObj), isLoading: false }
        );
      });
  }

  changeHandler = (item, multiselect) => {
    if (item.code === 'ALL') {
      this.setState({ resortChecked: {} });
    } else {
      this.setState((prevState) => {
        let resortChecked = { ...prevState.resortChecked };

        if (multiselect) {
          if (resortChecked.hasOwnProperty(item.code)) {
            delete resortChecked[item.code];
          } else {
            resortChecked[item.code] = item;
          }
        } else {
          resortChecked = { [item.code]: item };
        }

        return { resortChecked, priceChecked: {}, bookNowPopover: null };
      }, this.getData);
    }
  }

  priceChangeHandler = (item, multiselect, index) => {
    this.setState((prevState) => {
      const priceChecked = { ...prevState.priceChecked };

      priceChecked[index] = { [item.id]: item };

      return { priceChecked };
    });
  }

  tabsHandler = (el) => {
    this.setState({ tabChecked: { [el.id]: el } });
  }

  render() {
    const { tabChecked, resortChecked, priceChecked, isLoading, eventsData, bookNowPopover} = this.state;
    const selectedTab = Object.values(tabChecked)[0];
    const selectedResort = Object.values(resortChecked)[0];

    let servicesList = <Spinner />;
    let eventsList = <Spinner />;

    let filtredData = eventsData;
    let filteredItems;

    if (selectedTab.paramId !== null) {
      filtredData = eventsData.filter((el) => el.groupId === selectedTab.paramId);
    }

    if (!isLoading) {

      filteredItems = filtredData.length;

      eventsList = filtredData.map((event, index) => {

        const selectedHandler = (item, multiselect) => {
          this.priceChangeHandler(item, multiselect, index);
        };

        const bookNowHandler = (action) => {
          this.setState({ bookNowPopover: action ? index : null });
        };

        const rates = event.rates.map((el, id) => ({
          id: id,
          rate: el.rate,
          label: `${el.duration || 0} Minutes - $${el.rate || 0}`
        }));


        const props = {
          key: index,
          images: event.mainImages,
          name: event.eventName,
          rates: rates,
          description: event.descriptionWithoutHtml,
          checked: priceChecked[index] || {},
          onSelected: selectedHandler,
          onBookNow: bookNowHandler,
          resortChecked: Object.values(resortChecked)[0].shortName
        };

        const resortName = resortList.find((resort) => resort.code === event.rstCode).shortName;

        if (bookNowPopover === index) {
          if (priceChecked.hasOwnProperty(bookNowPopover)) {
            props.popover = (
              <ClickOut callback={() => this.setState({ bookNowPopover: null })}>
                <BookPopover closeup={() => bookNowHandler(false)}>
                  <h3 className="popover-qq-ttl opensans-semibold">Enter your Holiday dates</h3>
                  <span className="popover-qq-rst-ttl display-block opensans-semibold">{resortName}</span>
                  <QuickQuote
                    schedulerModeIndex={ 4 }
                    hasCountries={ false }
                    brand="beaches"
                    noLabels
                    hasResorts={ false }
                    hasOccupancy={ false }
                    reference="oee"
                    oeeRequest={ false }
                    defaultResortCode={ event.rstCode }
                    eventID={ event.eventId }
                    groupID={ event.groupId }
                    occupancyLabels={ false }
                    schedulerModeIndex={ 1 }
                    quoteButtonText="Continue"
                    className="qq landing qq-popover"
                    startDatePlaceholderText="Check In Date"
                    endDatePlaceholderText="Check Out Date"
                    confirmationNumber
                    notOeeRequest
                  />
                </BookPopover>
              </ClickOut>
            );
          } else {
            props.validationPopover = (
              <ClickOut callback={() => this.setState({ bookNowPopover: null })}>
                <BookPopover closeup={() => bookNowHandler(false)}>
                  <Fragment>
                    <h6 className="title">Select Option First</h6>
                    <p className="validation-text">Please select the duration of the treatment you would like to book.</p>
                  </Fragment>
                </BookPopover>
              </ClickOut>
            );
          }
        }

        return <EventItem { ...props } />;
      });
    }

    servicesList = (
      <Fragment>
        {eventsList}
      </Fragment>
    );

    return (
      <Fragment>
        <div className="resorts-select">
          <div className="resorts-select-title">
            Select a Resort to view our treatments:
          </div>
          <Select
            theme="resorts"
            data={resortList}
            markedKey="code"
            groupByKey="countryName"
            checked={resortChecked}
            placeholder="Select Resort"
            onChange={this.changeHandler}
            onOpen={() => this.setState({ priceChecked: {} })}
            labelKey="shortName"
          />
        </div>
        <div className="tabs-wrap">
          <div className="container">
            {selectedResort && <ul className="tabs">
              {tabs.map((el, index) => {
                let className;

                if (tabChecked[el.id]) { className = 'active'; }

                return (
                  <li
                    key={index}
                    className={className}
                    onClick={() => this.tabsHandler(el)}
                  >
                    <span>{el.label}</span>
                  </li>
                );
              })}
            </ul>}

            {selectedResort && <Select
              className="tabs-select"
              data={tabs}
              checked={tabChecked}
              placeholder="View All Treatments"
              onChange={this.tabsHandler} />}
          </div>
        </div>
        {selectedResort && <div className="container sessions-list-wrap">
          {!isLoading && <h5 className="sessions-list-title">{filteredItems} treatments found <span className="resort-name">at {selectedResort.shortName}</span></h5>}
          <div className="sessions-list">
            {servicesList}
            <p class="intro-disclaimer-sessions-list"><strong>PLEASE NOTE: </strong>Certain treatments and techniques may not be suitable for persons who are pregnant, injured, or who have certain medical conditions. We recommend that you check with your physician before booking any spa services. </p>
          </div>
        </div>}
      </Fragment>
    );
  }
}
